import { useCallback, useEffect, useRef, useState } from 'react';
import { useSwipeEvents } from 'beautiful-react-hooks';
import { getTransformationValues, scrollToTab, smoothScrollTo } from './utils';
var getCurrentSlideIndex = function (slides, value) { return slides.findIndex(function (_a) {
    var id = _a.id;
    return id === value;
}); };
/**
 * Handles the slider controls business logic
 * @param center
 * @param value
 * @param slides
 * @param scrollInterval
 */
var useControls = function (_a) {
    var center = _a.center, value = _a.value, slides = _a.slides, scrollInterval = _a.scrollInterval;
    var _b = useState(getCurrentSlideIndex(slides, value)), scrollPosition = _b[0], setScrollPosition = _b[1];
    var scrollerRef = useRef(null);
    var transposedXRef = useRef(null);
    var _c = useSwipeEvents(scrollerRef), onSwipeStart = _c.onSwipeStart, onSwipeMove = _c.onSwipeMove, onSwipeEnd = _c.onSwipeEnd;
    var _d = useState(false), isSwiping = _d[0], setIsSwiping = _d[1];
    useEffect(function () {
        if (center && !!value) {
            var itemIndex = getCurrentSlideIndex(slides, value);
            setScrollPosition(itemIndex);
        }
    }, [center, value]);
    useEffect(function () {
        if (scrollPosition > 0) {
            scrollToTab(scrollPosition);
        }
    }, [scrollPosition]);
    var prevSlide = useCallback(function () {
        var interval = scrollInterval || 5;
        var nextPosition = scrollPosition - interval;
        if (nextPosition >= 0) {
            setScrollPosition(nextPosition);
            return;
        }
        setScrollPosition(0);
    }, [scrollPosition, scrollInterval, setScrollPosition]);
    var nextSlide = useCallback(function () {
        var interval = scrollInterval || 5;
        var nextPosition = scrollPosition + interval;
        if (nextPosition < slides.length) {
            setScrollPosition(nextPosition);
            return;
        }
        setScrollPosition(slides.length - 1);
    }, [scrollPosition, scrollInterval, setScrollPosition, slides]);
    onSwipeStart(function () {
        var x = getTransformationValues(scrollerRef.current).x;
        transposedXRef.current = x;
    });
    onSwipeMove(function (_a) {
        var alphaX = _a.alphaX;
        if (transposedXRef.current) {
            setIsSwiping(true);
            smoothScrollTo(alphaX, transposedXRef.current, scrollerRef.current);
        }
    });
    onSwipeEnd(function () {
        transposedXRef.current = null;
        setTimeout(function () {
            setIsSwiping(false);
        }, 250);
    });
    return { prevSlide: prevSlide, nextSlide: nextSlide, scrollerRef: scrollerRef, isSwiping: isSwiping };
};
export default useControls;
